<script setup lang="ts">
interface WorkforceAchievement {
    count: string;
    title: string;
}

withDefaults(defineProps<{
    subheading?: string;
    description?: string;
    achievements?: WorkforceAchievement[];
    containerClass?: string
    appendClass?: string
}>(), {
    subheading: 'Your Partner in <br class="max-md:hidden" /> Workforce Growth',
    description: 'Build a dream product team with us. Lower your overhead cost and employer commitments.',
    achievements: () => [
        { count: '100+', title: 'Trained IT Professional' },
        { count: '40+', title: 'Laravel<br> Developer' },
        { count: '60+', title: 'Frontend, UI/UX, DevOps, Testers' },
        { count: '10+', title: 'Agencies hired <br>from us' },
    ],
});
</script>

<template>
    <div class="flex flex-col lg:flex-row gap-10 justify-between">
        <div class="mt-4 max-lg:text-center">
            <p v-html="subheading" class="text-3xl md:text-[3rem] md:min-w-max leading-tight">
            </p>
            <p class="text-medium md:mt-3 tracking-[0.5px]">
                {{ description }}
            </p>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-[#1E1B4B] dark:text-white">
            <div v-for="item in achievements" class=" rounded-xl p-px h-full text-[#1E1B4B] dark:text-white"
                :class="containerClass ? containerClass : 'bg-[image:var(--border-staff-card)]'">
                <div class="py-6 px-4 rounded-xl text-center  h-full"
                    :class="appendClass ? appendClass : 'bg-[image:var(--bg-staff-card)]'">
                    <p class="font-semibold text-5xl md:text-6xl max-sm:text-3xl mb-2">
                        {{ item.count }}
                    </p>
                    <p class="text-medium md:text-lg max-sm:text-sm line-clamp-3" v-html="item.title">

                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
